import { render, staticRenderFns } from "./DeleteOrganizationUsers.vue?vue&type=template&id=0c8f547a&scoped=true&"
import script from "./DeleteOrganizationUsers.vue?vue&type=script&lang=js&"
export * from "./DeleteOrganizationUsers.vue?vue&type=script&lang=js&"
import style0 from "./DeleteOrganizationUsers.vue?vue&type=style&index=0&id=0c8f547a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8f547a",
  null
  
)

export default component.exports